import { useState, type FormEvent } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ApiError } from '../lib/api';
import { ErrorNote } from '../components/ui';

export function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation() as { state?: { from?: string } };
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      await login(email, password);
      navigate(location.state?.from ?? '/app', { replace: true });
    } catch (err) {
      if (err instanceof ApiError && err.status === 429) setError('Too many attempts — try again in 15 minutes.');
      else setError('Invalid email or password.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="flex min-h-full items-center justify-center px-4 py-20">
      <div className="card w-full max-w-sm">
        <div className="mb-6 text-center">
          <div className="text-lg font-bold">
            <span className="bg-gradient-to-r from-brand-400 to-cyan-400 bg-clip-text text-transparent">VibeProSoft</span>{' '}
            <span className="text-slate-200">Navigator</span>
          </div>
          <p className="mt-1 text-xs text-slate-500">Consultant cockpit — sign in</p>
        </div>
        {error && <ErrorNote message={error} />}
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="label" htmlFor="email">Email</label>
            <input id="email" type="email" required className="input" value={email}
                   onChange={(e) => setEmail(e.target.value)} autoComplete="username" />
          </div>
          <div>
            <label className="label" htmlFor="password">Password</label>
            <input id="password" type="password" required className="input" value={password}
                   onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" />
          </div>
          <button type="submit" disabled={busy} className="btn-primary w-full">
            {busy ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
        <p className="mt-4 text-center text-xs text-slate-600">
          Accounts are provisioned by an admin. <Link to="/" className="text-brand-400 hover:underline">← Back to site</Link>
        </p>
      </div>
    </div>
  );
}
